export const updateCheckoutItemRejectedAction = (state) => {
	state.orderSummary.isLoading = false;
};
